import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, HostListener } from '@angular/core';
import { NotificationService } from 'src/@core/services/notification.service';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatDialog,
  MatFormFieldDefaultOptions,
} from '@angular/material';
import { BehaviorSubject, Subscription, merge, of as observableOf } from 'rxjs';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { Search } from 'src/@core/interfaces/search';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { JobService } from 'src/@core/services/job/job.service';
import { AppService } from 'src/@core/services/app.service';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions'
import { Router } from '@angular/router';
import { STATUS } from 'src/app/shared/helpers/status';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import { HttpParams } from '@angular/common/http';
import { PayBillComponent } from '../pay-bill/pay-bill.component';
declare var Razorpay: any;

@Component({
  selector: 'hour4u-admin-bill-list',
  templateUrl: './bill-list.component.html',
  styleUrls: ['./bill-list.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'standard'
      } as MatFormFieldDefaultOptions
    }
  ]
})
export class BillListComponent implements OnInit {
  dataChange: BehaviorSubject<any>;
  @Input() data?: any;
  roles = roles;
  entityTypes = entityTypes;
  permissions = permissions;
  resultsLength = 0;
  title = 'Job';
  columns = [
    { columnDef: 'billName', visible: true, label: 'Bill name' },
    { columnDef: 'status', visible: true, label: 'Status' },
    { columnDef: 'agency', visible: true, label: 'Agency' },
    { columnDef: 'client', visible: true, label: 'Client' },
    { columnDef: 'amount', visible: true, label: 'Bill amount' },
    { columnDef: 'toBePaidBy', visible: true, label: 'To be paid by' },
    { columnDef: 'action', visible: true, label: 'Action' },
  ];
  displayedColumns = this.columns.map(x => x.columnDef);
  profile = this.appService.getCurrentAccount();
  pageSize = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  prevUrl: String;
  searchParams: Array<Search> = [];
  loginUserDetails: any = null;
  row: any;
  sort_field: string = '';
  diameter = 40;
  color: string;
  mode = 'indeterminate';
  status = STATUS;
  selectedAgency: any = null;
  selectedCreatedOn: any = null;
  selectedToBePaidBy: any = null;
  isLoading: boolean = false;
  billList: any[] = [];
  screenWidth = window.innerWidth;
  summaryData: any = null;
  multiselectOptions = [
    { value: 'APPROVED', label: 'Approved' },
    { value: 'DRAFT', label: 'Draft' },
    { value: 'APPROVAL_PENDING', label: 'Approval Pending' },
    { value: 'PAYMENT_SUCCESS', label: 'Paid' },
  ];

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
  }
  subscrier: Subscription;
  mainBillList: any[] = [];
  billsGeneratedAgencies: any[] = [];
  searchBillName: string = "";
  selectedStatus: string = '';
  selectedBill: any = null;
  timeoutRef: ReturnType<typeof setTimeout>;

  constructor(
    private service: JobService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private notify: NotificationService,
    private appService: AppService,
    private dialog: MatDialog
  ) {

    this.subscrier = this.service.getRefreshBillingPage().subscribe(res => {
      this.getBillsList();
      this.fetchBillSummary();
    });
  }

  ngOnInit() {
    this.dataChange = new BehaviorSubject(0);
    if (this.data) {
      this.fetchBillSummary();
      this.getBillsList();
    }
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  fetchBillSummary() {
    this.isLoading = true;
    this.service.fetchBillingSummary(this.data.id.toString()).subscribe(
      (response) => {
        this.isLoading = false;
        this.summaryData = response;
      }, (err => {
        this.isLoading = false;
      }))
  }

  getBillsList() {
    this.isLoading = true;
    this.billList = [];
    let entityId = "";
    if (this.profile.entity.entityType === 'AGENCY') {
      entityId = '&createdByEntityId=' + this.profile.entity.id;
    }

    if (this.profile.entity.entityType === 'ENTERPRISE') {
      entityId = '&paidByEntityId=' + this.profile.entity.id;
    }
    let params = new HttpParams()

    if (this.selectedAgency) {
      if (Array.isArray(this.selectedAgency)) {
        this.selectedAgency.forEach(agency => {
          params = params.append('agencyId', agency);
        });
      } else {
        params = params.set('agencyId', this.selectedAgency);
      }
    }

    if (this.selectedStatus) {
      if (Array.isArray(this.selectedStatus)) {
        this.selectedStatus.forEach(agency => {
          params = params.append('status', agency);
        });
      } else {
        params = params.set('status', this.selectedStatus);
      }
    }

    if (this.selectedToBePaidBy) {
      params = params.set('payBefore', moment(this.selectedToBePaidBy).format("YYYY-MM-DD"));
    }

    if (this.searchBillName) {
      params = params.set('title', this.searchBillName);
    }

    this.service.getBillingList(this.data.id.toString(), entityId, params).subscribe(
      (response) => {
        this.isLoading = false;
        this.billsGeneratedAgencies = [];
        let billsGeneratedAgencies = [];
        this.billList = response;
        this.mainBillList = response;
        this.mainBillList.forEach(ele => {
          billsGeneratedAgencies.push(ele.billingRaisedBy);
        })
        this.billsGeneratedAgencies = this.removeDuplicates(billsGeneratedAgencies);
        this.resultsLength = this.billList.length;
        this.columnHideBasedOnLoggedInUser();
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch bills:', error);
      }
    );
  }

  // remove all duplicate name from array
  removeDuplicates(array) {
    let items = array.filter((test, index, array) =>
      index === array.findIndex((findTest) =>
        test.id.trim() && findTest.id.trim() === test.id.trim()
      )
    );
    return items;
  }

  columnHideBasedOnLoggedInUser() {
    if (this.profile.entity.entityType === 'ENTERPRISE') {
      this.columns = this.columns.map(x => {
        x.visible = true;
        if (x.columnDef === 'checkbox' || x.columnDef == 'client')
          x.visible = false;
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }

    if (this.profile.entity.entityType === 'AGENCY') {
      this.columns = this.columns.map(x => {
        x.visible = true;
        if (x.columnDef === 'agency')
          x.visible = false;
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }
  }

  dataRefresh() {
    this.ngOnInit();
  }

  // edit Field
  editBill(row) {
    this.data.billingData = row;
    this.data.billingTitle = row.title;
    this.service.saveBillingData(this.data);
    this.router.navigateByUrl("/job/create-bill/" + row.jobId);
  }

  // accept Reject PO
  acceptRejectBill(data, status) {
    this.service.updateBillingStatus(data.id, status).subscribe(res => {
      this.dataRefreshIndividualRow(res);
      this.fetchBillSummary();
      this.notify.showMessage('Billing Status Updated Successfully!', 2000);
    }, ((err: any) => {
      this.notify.showMessage(err.error.message, 2000);
    }))
  }

  // refresh individual row
  dataRefreshIndividualRow(res) {
    this.billList.forEach((ele: any, index) => {
      if (ele.id == res.id) {
        this.billList[index] = res;
        this.billList = [...this.billList];
        console.log(this.billList)
        this.cdRef.detectChanges();
      }
    })
  }

  // Payment options
  razorPayOptions = {
    "key": '',
    "amount": 0,
    "currency": '',
    "name": '',
    "discription": "Workorbit's Billing",
    "order_id": '',
    "handler": (response) => {
      console.log("response=====", response)
      this.service.updateBillingStatus(this.selectedBill.id, 'PAYMENT_SUCCESS').subscribe(res => {
        this.dataRefreshIndividualRow(this.selectedBill);
        this.fetchBillSummary();
        this.notify.showMessage('Billing paid successfully!', 2000);
        this.selectedBill = null;
      }, ((err: any) => {
        this.notify.showMessage(err.error.message, 2000);
      }))
    }
  };

  // Pay Bill
  // payBill(row: any) {
  //   console.log(row)
  //   this.selectedBill = row;
  //   this.razorPayOptions.amount = row.totalAmount
  //   this.razorPayOptions.currency = 'INR';
  //   this.razorPayOptions.key = environment.rezorpayKey;
  //   this.razorPayOptions.order_id = row.paymentDetails.razorPayOrderId;
  //   console.log("this.razorPayOptions", this.razorPayOptions)
  //   var rzp = new Razorpay(this.razorPayOptions);
  //   rzp.open()
  //   rzp.on('payment.failed', function (response) {
  //     console.log("response--", response)
  //     alert(response.error.code);
  //     alert(response.error.description);
  //     alert(response.error.source);
  //     alert(response.error.step);
  //     alert(response.error.reason);
  //     alert(response.error.metadata.order_id);
  //     alert(response.error.metadata.payment_id);
  //   });
  // }

  // Pay Bill
  payBill(row: any) {
    const dialogRef = this.dialog.open(PayBillComponent, {
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      autoFocus: true,
      minWidth: "500px",
      data: row
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getBillsList();
      }
    });
  }

  filterBy() {
    this.getBillsList();
  }

  clearAgencySelection(eventData: any) {
    eventData.stopPropagation();
    this.selectedAgency = null;
    this.getBillsList();
  }

  clearPaidByDateSelection(eventData: any) {
    eventData.stopPropagation();
    this.selectedToBePaidBy = null;
    this.getBillsList();
  }

  clearStatusSelection(eventData: any) {
    eventData.stopPropagation();
    this.selectedStatus = null;
    this.getBillsList();
  }

  searchByBillName() {
    clearTimeout(this.timeoutRef);
    this.timeoutRef = setTimeout(() => {
      this.getBillsList();
    }, 700);
  }

  clearSearch() {
    this.searchBillName = '';
    this.getBillsList();
  }

  viewBilling(row) {
    this.data.billingData = row;
    this.data.billingTitle = row.title;
    this.data.isView = true;
    this.service.saveBillingData(this.data);
    this.router.navigateByUrl("/job/create-bill/" + row.jobId);
  }

  ngOnDestroy() {
    this.subscrier.unsubscribe();
    clearTimeout(this.timeoutRef);
  }
}
